import SpriteSymbol from "../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "SolidDropdownLeft",
  "use": "SolidDropdownLeft-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"SolidDropdownLeft\"><defs><path d=\"M15 8.09v7.82c0 .602-.48 1.09-1.074 1.09-.285 0-.558-.115-.76-.32l-3.851-3.909a1.102 1.102 0 0 1 0-1.542l3.851-3.91c.42-.425 1.1-.425 1.52 0 .2.205.314.482.314.771z\" id=\"SolidDropdownLeft_solid-dropdown-left\" /></defs><use xlink:href=\"#SolidDropdownLeft_solid-dropdown-left\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol